/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'coal-export': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.73 15.438v2.795l-3.386.236-.5 2.165-1.573-2.401h-1.99L8.437 22.53l20.99-.417 4.198-3.539 1.22-.919v-1.625h-.813l-.407-1.625h-.812l-.813.406h-.812l-.813 1.626-.947-.694-1.896-.931h-1.625l-1.22.93h-2.03L21.03 14l-2.301 1.438zm16.53 2.393l-5.648 4.76L6 23.119v7.404l11.545 2.84A8.814 8.814 0 1028.21 41.98h9.518a8.814 8.814 0 1017.583-.88H58v-3.526h-1.057l-.794-9.519h-6.081v-6.17H40.374l-7.136 10.477v-3.758l6.077-8.922h13.91v-1.85H35.261zm15.16 24.15a3.878 3.878 0 11-7.756 0 3.878 3.878 0 017.756 0zm-1.939-13.926h-6.463v-4.583h6.463v4.583zM19.396 45.859a3.878 3.878 0 110-7.757 3.878 3.878 0 010 7.757z" _fill="#EF7812"/>'
  }
})
